import { reducer } from "./redux";
import { IFeatureEntry } from "../../types/feature";
import { PREFIX as SERVICE_PREFIX } from "./const";
import sagas from "./sagas";

const entry: IFeatureEntry = {
  reducer,
  sagas,
};

type Entry = typeof entry;

export { entry, SERVICE_PREFIX };
export type { Entry };
